function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 23"
}, props), React.createElement("path", {
  d: "M4.917 22.263l2.018-8.231L.168 8.495l8.94-.732L12.584 0l3.477 7.763 8.94.732-6.768 5.537 2.018 8.231-7.667-4.364-7.667 4.364z",
  fill: "#57A1BB"
})));